<!DOCTYPE html>
<template>
	<!--
	Dashboard
		TODO:
			left pane navigation (use components if possible)
				Admin (target 20200712)
					Create users (see Register)
						- Partially done, migrate to use Firebase Admin + FCF
					(using Admin SDK+FCF) Disable user
				Encoders (target 20200718)
					Create entry (metadata)
						- Company Name
						- data - map
						- dateCreated
						- userId
						- type -> to follow for purpose
			main content
				Admin
					list of users (activate/deactivate)
						- list OK
						- activate/deactivate - to follow
				Encoders
					list of entries made by userId
	-->
	<main id="main-content" class="container py-4">
		<div class="d-flex justify-content-end align-items-center mb-2">
			<label for="orgadmin-per-page" class="mr-2 mb-0 small text-muted">Show:</label>
			<b-form-select id="orgadmin-per-page" v-model="perPage" :options="perPageOptions" size="sm" style="width:auto"/>
		</div>
		<b-table
			id="users-table"
			striped hover responsive
			:items="userList"
			:fields="userFields"
			:per-page="perPage"
			:current-page="currentPage"
			show-empty
			empty-text="No users in your organization."
		>
			<template #cell(name)="data">
				{{ data.item.lastName }}, {{ data.item.firstName }} {{ data.item.middleName }}
			</template>
			<template #cell(actions)="data">
				<b-button
					size="sm"
					variant="outline-primary"
					@click="updateUserClaims(data.item.uid)"
					:aria-label="'Update user claims for ' + data.item.firstName + ' ' + data.item.lastName"
				>Update Claims</b-button>
			</template>
		</b-table>
		<b-pagination
			v-model="currentPage"
			:total-rows="userList.length"
			:per-page="perPage"
			align="center"
			aria-controls="users-table"
			class="mt-3"
		/>
	</main>
</template>

<style lang="scss" scoped>
</style>
<script>
	import firebase from "firebase/compat/app";
	import "firebase/compat/auth";
	import "firebase/compat/firestore";
	import axios from "axios";
	const config = require("../firebaseconfig.js");

	class User {
		constructor () {
		
		}
	}
	export default {
		mounted: function() {
			var currentUserId = firebase.auth().currentUser.uid;
			firebase.firestore().collection("Users").doc(currentUserId).get()
				.then(userDocSnapshot => {
					var data = userDocSnapshot.data();

					this.organizationName = data.organizationName;
					this.getUserList();
				});
		},
		methods: {
			getUserList: async function() {
				if (!this.organizationName) return;
				this.userList = [];
				firebase.firestore().collection("Users").where("organizationName", "==", this.organizationName)
					.get().then(data => {
						if (!data.empty) {
							data.forEach(result => {
								var user_ = result.data();
								
								var user = new User();
								user.uid = result.id;
								user.firstName = user_.firstName;
								user.middleName = user_.middleName;
								user.lastName = user_.lastName;
								user.birthdate = user_.birthdate;
								user.prcId = user_.prcId;
								user.fullAddress = user_.fullAddress;
								user.role = user_.role;
								
								this.userList.push(user);
							});
						}
					}).catch(refError => {
						console.error("refError " + refError);
					}).finally(() => {
						return this.userList;
					});
			},
			updateUserClaims(_uid) {
				var req = {
					uid : _uid
				};
				axios.post(config.functionBaseUrl + "/updateUserClaims", req)
					.then(response => {
						//TODO: update dashboard list
						this.$bvToast.toast('User claims updated for ' + _uid, {
							title: 'Success', variant: 'success', solid: true, autoHideDelay: 4000
						});
						return;
					}).catch(error => {
						console.error("error  " + error);
						this.$bvToast.toast('Failed to update user claims for ' + _uid, {
							title: 'Error', variant: 'danger', solid: true, noAutoHide: true
						});
					}
				);
			},
		},
		data() {
			return {
				uid: "",
				firstName: "",
				middleName: "",
				lastName: "",
				birthdate: null,
				fullAddress: "",
				prcId: "",
				email: "",
				password: "",
				confirmPassword: "",
				role: -1,
				organizationName: "",
				error: "",
				userList: [],
				perPage: 10,
				currentPage: 1,
				perPageOptions: [10, 20, 50],
				userFields: [
					{ key: 'name', label: 'Name' },
					{ key: 'prcId', label: 'PRC ID' },
					{ key: 'actions', label: 'Actions' }
				],
			}
		}
	}
</script>
